import { useState, useRef, useEffect } from 'react'
import {askBot, RetrieveMatchings, sendConversationToBdd} from "@/lib/api-chatbot-client";


export function useConversation(userId, sessionId) {
    const [input, setInput] = useState("")
    const [isTyping, setIsTyping] = useState(false)
    const [isPlan, setIsPlan] = useState(false)
    const [isMatch, setIsMatch] = useState(false)
    const [matchResults, setMatchResults] = useState([])
    const messagesEndRef = useRef(null)

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
    }

    useEffect(() => {
        scrollToBottom()
    }, [])

    const handleBotResponse = async (input, setMessages) => {
        setIsTyping(true)

        setTimeout(async () => {
            const response = await askBot(input)

            if (response.intention == "planification") {
                setIsPlan(true)
                setIsTyping(false)
                return
            }

            if (response.intention === "recherche_membres") {
                try {
                    const retrievalResponse = await RetrieveMatchings(input)
                    setMatchResults(retrievalResponse.results)
                    setIsMatch(true)
                } catch (err) {
                    console.error(err)
                }
                setIsTyping(false)
                return
            }

            setMessages(prev => [...prev, {
                id: prev.length + 1,
                text: response.answer,
                sender: 'bot',
                timestamp: new Date().toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
            }])

            sendConversationToBdd('bot', response.answer, userId, sessionId)
            setIsTyping(false)
        }, 1000)
    }

    return {
        input,
        setInput,
        isTyping,
        setIsTyping,
        isPlan,
        setIsPlan,
        isMatch,
        setIsMatch,
        matchResults,
        setMatchResults,
        messagesEndRef,
        scrollToBottom,
        handleBotResponse
    }
}